var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgStar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 27,
  height: 26,
  viewBox: "0 0 27 26"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "nonzero",
  d: "m26.816 10.205-6.53 5.84 1.738 9.048a.56.56 0 0 1-.807.603l-7.687-3.969-7.688 3.966a.56.56 0 0 1-.807-.607l1.789-9.034-6.521-5.848a.56.56 0 0 1 .287-.966L9.185 7.85 13.062.304a.56.56 0 0 1 .996 0l3.877 7.546 8.594 1.388a.56.56 0 0 1 .287.967Z"
})));
export default SvgStar;